import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import ResponsiveGrid from "../grid/responsiveGrid";

import { DEGRADED_COLOR, DEGRADED_OUTAGE_COLOR, FAILURE_COLOR, ONLINE_COLOR } from "./hmsUtil";

import { CustomPagination } from "../customPagination";

const HimsFaultDialog = ({ selectedFaultComponent, setSelectedFaultComponent }) => {
    const faultColumns = [
        {
            field: "severity",
            headerName: "Severity",
            flex: 1,
            maxWidth: 100
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            maxWidth: 150
        },
        {
            field: "description",
            headerName: "Description",
            flex: 1
        }
    ];
    return (
        <Dialog open={true} onClose={() => setSelectedFaultComponent(null)} maxWidth="sm" fullWidth>
            <DialogContent sx={{ pb: 0 }}>
                <Box
                    sx={{
                        marginTop: "5px",
                        "& .high": { backgroundColor: FAILURE_COLOR },
                        "& .medium": { backgroundColor: DEGRADED_OUTAGE_COLOR },
                        "& .low": { backgroundColor: DEGRADED_COLOR },
                        "& .nominal": { backgroundColor: ONLINE_COLOR }
                    }}
                >
                    <ResponsiveGrid
                        disableVirtualization
                        autoHeight
                        rows={selectedFaultComponent.faults}
                        columns={faultColumns}
                        disableRowSelectionOnClick
                        getRowId={(row) => row.name}
                        pagination
                        slots={{ pagination: CustomPagination }}
                        initialState={{ pagination: { paginationModel: { pageSize: 8 } } }}
                        getCellClassName={(params) => {
                            if (params.field === "severity") {
                                return params.value.toLowerCase();
                            }
                            return "";
                        }}
                        sx={{ bgcolor: "#121212" }}
                        getRowHeight={() => "auto"}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setSelectedFaultComponent(null)}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default HimsFaultDialog;
